DOMReady( function(){
  // burger togglers
	[... document.querySelectorAll('.burgermenutoggler')].map( burgermenutogglerEl => {
		burgermenutogglerEl.addEventListener( 'click', (event) => {
			event.preventDefault();
      if( burgermenutogglerEl.dataset.target && document.querySelector( burgermenutogglerEl.dataset.target ) ){
        if( document.querySelector( burgermenutogglerEl.dataset.target ).classList.contains( 'show' ) ){
          document.querySelector( burgermenutogglerEl.dataset.target ).classList.remove( 'show' );
          document.documentElement.classList.remove( 'burgeropened' );
          [... document.querySelectorAll('.burgermenutoggler')].map( burgermenutogglerbisEl => {
            burgermenutogglerbisEl.setAttribute('aria-expanded', "false" );
            burgermenutogglerbisEl.classList.add('collapsed');
          });
        } else {
          document.querySelector( burgermenutogglerEl.dataset.target ).classList.add( 'show' );
          document.documentElement.classList.add( 'burgeropened' );
          [... document.querySelectorAll('.burgermenutoggler')].map( burgermenutogglerbisEl => {
            burgermenutogglerbisEl.setAttribute('aria-expanded', "true" );
            burgermenutogglerbisEl.classList.remove('collapsed');
          });
        }
      }
    });
	});

  //burger overlay click
  let burgermaindiv = document.querySelector( '#mainmenu-burger' );
  let burgercontentdiv = (burgermaindiv) ? burgermaindiv.querySelector( '.mainmenu-burger-content') : null;
  if( burgermaindiv && burgercontentdiv ){
    burgermaindiv.addEventListener( 'click', (event) => {
      let inBurgerContent = ( event.target == burgercontentdiv );
      if( event.target != burgercontentdiv && event.target.parentNode ){
        let parent = event.target.parentNode;
        while( parent != null ) {
          if ( parent.parentNode == burgercontentdiv ) {
            inBurgerContent = true;
          }
          parent = parent.parentNode;
        }
      }
      if( !inBurgerContent ){
        if( burgermaindiv.classList.contains( 'show' ) ){
          burgermaindiv.classList.remove( 'show' );
          document.documentElement.classList.remove( 'burgeropened' );
          [... document.querySelectorAll('.burgermenutoggler')].map( burgermenutogglerbisEl => {
            burgermenutogglerbisEl.setAttribute('aria-expanded', "false" );
            burgermenutogglerbisEl.classList.add('collapsed');
          });
        }
      }
    });
  }

  // Main menu dropdown
  [... document.querySelectorAll('[data-toggle="dropdown"]')].map( dropdowntogglerEl => {
    dropdowntogglerEl.addEventListener( 'click', (event) => {
			event.preventDefault();
      if( dropdowntogglerEl.classList.contains( 'show' ) ){
        dropdowntogglerEl.setAttribute( 'aria-expanded', "false" );
        dropdowntogglerEl.classList.remove( 'show' );
        dropdowntogglerEl.closest('.dropdown').querySelector('.dropdown-menu').classList.remove( 'show' );
      } else {
        dropdowntogglerEl.setAttribute('aria-expanded', "true" );
        dropdowntogglerEl.classList.add( 'show' );
        dropdowntogglerEl.closest('.dropdown').querySelector('.dropdown-menu').classList.add( 'show' );
      }
    });
  });
});
